import { DialogTitle } from "@mui/material";
import { quotationBusiness } from "api/bussiness/quotation/quotation-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddQuotation } from "mobx-stores/_models/quotation/quotation";
import { useStores } from "mobx-stores/_root-store";
import { useResetCustomerDependentControls } from "pages/common/hooks/use-reset-customer-dependent-controls";
import { useCallback, useMemo } from "react";
import { DialogComplexContent } from "share-components/templates/form/dialog-complex-form/dialog-complex-content";
import { DialogComplexFormContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form";
import { DialogComplexFormArrayContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form-array";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddQuotationFormSchema } from "../schema";

export const AddQuotation = observer(() => {
  const {
    quotationManagement: { openNew, getQuotations, setProp },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getControlArray,
    submitHandler,
  } = useForm<IAddQuotation>((form) => getAddQuotationFormSchema(form), {
    date: dateTimeToUTCString(dayjs()),
    number: "",
    items: [
      {
        amount: 0,
        note: "",
        productId: "",
        unitPrice: 0,
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddQuotation) => {
      try {
        await quotationBusiness.add(data);
        await getQuotations();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getQuotations, setProp],
  );

  const itemControl = useMemo(() => {
    return getControl("items");
  }, [getControl]);

  const customerControl = useMemo(() => {
    return getControl("customerId");
  }, [getControl]);

  const deliveryAddressControl = useMemo(() => {
    return getControl("deliveryAddressId");
  }, [getControl]);

  useResetCustomerDependentControls({
    customerId: customerControl.value,
    controls: [{ control: deliveryAddressControl }],
    arrayChildControls: [
      {
        arrayControl: itemControl,
        childControlName: "productId",
      },
    ],
  });

  const quotationItems = useMemo(() => {
    return getControlArray("items");
  }, [getControlArray]);

  const removeRowHandler = useCallback(
    (idx: number) => {
      itemControl.removeChildByIndex(idx);
    },
    [itemControl],
  );

  const addNewQuotationItemRow = useCallback(() => {
    itemControl.addNewChild();
  }, [itemControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"xl"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm phiếu báo giá</DialogTitle>
      <DialogComplexContent>
        <DialogComplexFormContainer>
          <DynamicForm controls={controls}></DynamicForm>
        </DialogComplexFormContainer>
        <DialogComplexFormArrayContainer
          label={itemControl.label}
          addNewRow={addNewQuotationItemRow}
        >
          {quotationItems && quotationItems.length > 0 && (
            <DynamicFormArray
              containerProps={{
                sx: {
                  marginTop: "10px",
                  marginBottom: "10px",
                },
              }}
              children={quotationItems}
              onRemoveRowClick={removeRowHandler}
            ></DynamicFormArray>
          )}
        </DialogComplexFormArrayContainer>
      </DialogComplexContent>
    </DialogForm>
  );
});
